import React, { useState } from 'react';

const MonthSelect = () => {
    // 현재 년도에 해당하는 월 선택
    const getCurrentMonth = () => {
        return new Date().getMonth() + 1;
    };

    // 1-12월 자동 생성
    const getCurrentYearMonths = () => {
        const months = [];
        for (let month = 1; month <= 12; month++) {
            months.push({ value: month.toString(), label: month.toString() });
        }
        return months;
    };

    const [selectMonth, setSelectMonth] = useState(getCurrentMonth().toString());
    const monthValue = getCurrentYearMonths();

    const handleChange = (event) => {
        setSelectMonth(event.target.value);
    };

    

    return (
        <select
            value={selectMonth}
            onChange={handleChange}
            style={{ width: '100%', padding: '0.5rem' }}
        >
            {monthValue.map((month) => (
                <option key={month.value} value={month.value}>{month.label}</option>
            ))}
        </select>
    );
};

export default MonthSelect;